import { Injectable } from '@angular/core';
import { FieldReferenceModel } from '@app/models/incident.model';
import { IncidentPatchModel } from '@app/pages/incidents/details-page/models/incident-patch.model';

export type JsonPatchOperationType = 'add' | 'remove' | 'replace' | 'test';
export interface JsonPatchOperation {
  op: JsonPatchOperationType;
  path: string;
  from?: string;
  value?: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class IncidentsJsonPatch {
  private operations: JsonPatchOperation[] = [];

  public addReplaceOperation(
    property: keyof IncidentPatchModel,
    value?: string | number | boolean | FieldReferenceModel[] | null | undefined,
  ): void {
    const propertyName = property.toLocaleString();
    const path = `/${propertyName[0].toLocaleUpperCase()}${propertyName.slice(1, propertyName.length)}`;
    this.operations.push({ op: 'replace', path: path, value: value });
  }

  public addTestOperation(property: 'version', value?: string): void {
    const propertyName = property.toLocaleString();
    const path = `/${propertyName[0].toLocaleUpperCase()}${propertyName.slice(1, propertyName.length)}`;
    this.operations.push({ op: 'test', path: path, value: value });
  }

  public getOperations(): JsonPatchOperation[] {
    return this.operations;
  }
}
